module.exports = __webpack_public_path__ + "img/gf.e2750b3e.svg";